import React, { useEffect, useState } from 'react';

import { formatUsername, getClassNames } from '../../../../../utils/util';

import './resource-views.scss';

type Props = {
  viewers?: string[];
  memberCount?: number;
  archived?: boolean;
};

const ResourceViews = ({ viewers = [], memberCount = 0, archived = false }: Props) => {
  const [viewersToDisplay, setViewersToDisplay] = useState<string[]>([]);
  const [showViewers, setShowViewers] = useState(false);
  const [columns, setColumns] = useState<string[][]>([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (viewers.length < 11) {
      setViewersToDisplay(viewers);
    } else if (!showAll) {
      setViewersToDisplay(structuredClone(viewers).splice(0, 10));
    } else {
      const copyOfViewers = structuredClone(viewers);
      const columns: string[][] = [];

      while (copyOfViewers.length) {
        const columnData = copyOfViewers.splice(0, 10);
        columns.push(columnData);
      }
      setColumns(columns);
    }
  }, [viewers, showAll]);

  return (
    <div className={getClassNames('resource-views', { archived })} onMouseLeave={() => setShowViewers(false)}>
      <div className="resource-views__view-count" onMouseEnter={() => setShowViewers(true)}>
        {viewers.length}/{memberCount} Views
      </div>
      {showViewers && viewers.length > 0 && (
        <div className="resource-views__viewer-container" onMouseLeave={() => setShowViewers(false)}>
          {!showAll && viewersToDisplay.map((viewer, index) => <p key={index}>{formatUsername(viewer)}</p>)}

          {!showAll && viewers.length > 10 && (
            <p className="resource-views__action" onClick={() => setShowAll(true)}>
              Show {viewers.length - 10} More
            </p>
          )}

          {showAll && viewers.length > 10 && (
            <div className="resource-views__column-container">
              {columns.map((column, index) => (
                <div key={`column-${index}`} className="resource-views__column">
                  {column.map((viewer, index) => (
                    <p key={index}>{viewer}</p>
                  ))}
                </div>
              ))}
            </div>
          )}

          {showAll && (
            <p className="resource-views__action" onClick={() => setShowAll(false)}>
              Show Less
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ResourceViews;
